import React, { useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";
import FilePreview from "components/Common/previewFile";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentPmeHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";
import DeleteButton from "components/Common/DeleteButtonShow";

import Config from "config";
import LastModificationAlert from "components/Common/Alert";
import LastModificationAlertShow from "components/Common/AlertShow";
import IdentificationCardPartenaire from "components/Common/IdentificationCardPartenaire";
import ReactInputMask from "react-input-mask";
import AuditCard from "components/Common/AuditCard";
const PmeDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modal_1, setModal_1] = useState(false);
  const [modal_2, setModal_2] = useState(false);
  const [modal_3, setModal_3] = useState(false);

  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [pmeData, setPmeData] = useState([]);
  const [souscriptions_en_cours, setSouscriptions_en_cours] = useState([]);
  const [operationData, setOperationData] = useState([]);
  const [investissements, setInvestissement] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [documentFusionData, setDocumentFusionData] = useState([]);
  const [souscriptions_finalisees, setSouscriptions_finalisees] = useState([]);
  const [btnsecondary1, setBtnsecondary1] = useState(false);
  // edit hm document
  const [docData, setDocData] = useState();
  const [docId, setDocId] = useState("");
  const [selectedCategories, setSelectedCategorie] = useState();
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  const [selectedPme, setSelectedPme] = useState();
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };

  const [selectedType, setSelectedType] = useState();
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const [selectedNom, setSelectedNom] = useState();
  const [selectedFichier, setSelectedFichier] = useState();

  const handleFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [selectedComment, setSelectedComment] = useState("");
  // New
  const [newCategories, setNewCategorie] = useState("");
  const [newType, setNewType] = useState("");
  const [newNom, setNewNom] = useState("");
  const [newFichier, setNewFichier] = useState("");
  const [newComment, setNewComment] = useState("");

  const handleNewCategorieChange = (e) => {
    setNewCategorie(e);
  };

  const handleNewTypeChange = (e) => {
    setNewType(e);
  };

  const handleNomChange = (e) => {
    setNewNom(e.target.value);
  };

  const handleNewFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setNewFichier(newFile);
    } else {
      setNewFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "PME | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={{ ...(type_compte == "client" ? navStyleClient : navStyle) }}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {type_compte == "client" && !loading ? (
              "Détails " + pmeData.sil
            ) : !loading ? (
              "Détails PME"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
        {pmeData?.hm_accessibles?.map((key, index) =>
          key === "hm_souscriptions_en_cours" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "souscriptions_en_cours" ? "active" : ""
                }`}
                onClick={() => handleTabClick("souscriptions_en_cours")}
              >
                {!loading ? (
                  souscriptions_en_cours?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_souscriptions_finalisees" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "souscriptions_finalisees" ? "active" : ""
                }`}
                onClick={() => handleTabClick("souscriptions_finalisees")}
              >
                {!loading ? (
                  souscriptions_finalisees?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_operations" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "operation" ? "active" : ""
                }`}
                onClick={() => handleTabClick("operation")}
              >
                {!loading ? (
                  operationData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_investissements" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "investissements" ? "active" : ""
                }`}
                onClick={() => handleTabClick("investissements")}
              >
                {!loading ? (
                  investissements?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents")}
              >
                {!loading ? (
                  documentData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents_fusions" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents_fusions" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents_fusions")}
              >
                {!loading ? (
                  documentFusionData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [downloadUrl1, setDownloadUrl1] = useState(null);

  const downloadLinkRef = useRef(null);
  const downloadLinkRef1 = useRef(null);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  useEffect(() => {
    if (downloadUrl && downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  }, [downloadUrl]);
  useEffect(() => {
    if (downloadUrl1 && downloadLinkRef1.current) {
      downloadLinkRef1.current.click();
    }
  }, [downloadUrl1]);
  const handleDropDownActionsClick = async (action) => {
    switch (action.action) {
      case "dupliquer":
        navigate(
          `${backUrl}/${action.controlleur}/${action.params.pme_id}/${action.action}`
        );
        break;
      case "export_comptable_form":
        navigate(
          `${backUrl}/${action.controlleur}/${action.params.pme_id}/${action.action}`
        );
        break;
      case "export_tableau_pme":
        toast.info("export du tableau en cours...");
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${action.action}?pme_id=${action.params.pme_id}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            setDownloadUrl(url);
            toast.success("Téléchargement en cours...");
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;

      case "export_2083":
        toast.info("export 2083 en cours...");
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controlleur}/${action.action}?pme_id=${action.params.pme_id}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.status == 200) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            setDownloadUrl1(url);
            toast.success("Téléchargement en cours...");
          } else {
            throw new Error(
              "La requête a échoué avec le statut " + response.status
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
        break;

      default:
        toast.error("Aucune action configurée");
        break;
    }
  };
  const getDocumentDetail = async (docId) => {
    try {
      await fetch(`https://www.fluxod.com/${api}/pme_documents/${docId}/edit`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setDocData(data);
          setSelectedCategorie(
            data?.detail_pme_document["Identification du documents"][
              "Catégorie"
            ]
          );
          setSelectedPme(
            data?.detail_pme_document["Identification du documents"]["PME"]
          );
          setSelectedType(
            data?.detail_pme_document["Identification du documents"]["Type"]
          );
          setSelectedNom(
            data?.detail_pme_document["Identification du documents"]["Nom"]
          );
          setSelectedFichier(
            data?.detail_pme_document["Identification du documents"]["Fichier"]
          );
          setSelectedComment(
            data?.detail_pme_document["Identification du documents"]
              .Commentaires
          );
          setModal(true);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [typeDocData, setTypeDocData] = useState({ data: [] });
  const renderTypeDocOptions = () => {
    return [
      {
        options: typeDocData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getTypeDoc = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/pme_documents/types_documents?id=${docId}&categories_document_id=${
          selectedCategories?.value || newCategories?.value
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTypeDocData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [categorieData, setCategorieData] = useState({ data: [] });
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getCategorieDocument = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/pme_documents/categories_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setCategorieData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleNewSubmit = async () => {
    if (newCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (newType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (newFichier == null || "") {
      toast.error("Merci de renseigner un fichier");
    } else {
      document.getElementById("create_button").disabled = true;
      const formData = new FormData();
      formData.append("pme_id", id);
      formData.append("fichier", newFichier);
      formData.append("categories_document_id", newCategories?.value);
      formData.append("types_document_id", newType?.value);
      formData.append("nom", newNom);
      formData.append("commentaires", newComment);
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/pme_documents/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Ajouté");
          setModal_1(false);
          getDocumentHm();
        } else {
          document.getElementById("create_button").disabled = false;
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (responseData && responseData.pme_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.pme_document_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const getDocumentHm = async () => {
    try {
      await fetch(`https://www.fluxod.com/${api}/pmes/${id}/hm_documents`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setDocumentData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleUpdateSubmit = async () => {
    if (selectedCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (selectedType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("id", docId);
        formData.append("pme_id", id);
        formData.append("fichier", selectedFichier);
        formData.append("categories_document_id", selectedCategories?.value);
        formData.append("types_document_id", selectedType?.value);
        formData.append("nom", selectedNom);
        formData.append("commentaires", selectedComment);
        const response = await fetch(
          `https://www.fluxod.com/${api}/pme_documents/${docId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Modifié");
          getDocumentHm();
          setLoading(false);
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          setLoading(false);
          if (responseData && responseData.pme_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.pme_document_validation[0];
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const [operationTypeData, setOperationTypeData] = useState([]);
  const getOperationType = async () => {
    try {
      await fetch(`https://www.fluxod.com/${api}/operations/operation_types`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setOperationTypeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderOperationTypeOptions = () => {
    return [
      {
        options: operationTypeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [investisseurData, setInvestisseurData] = useState([]);
  const getInvestisseur = async () => {
    try {
      await fetch(`https://www.fluxod.com/${api}/operations/investisseurs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setInvestisseurData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseurOptions = () => {
    return [
      {
        options: investisseurData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  // New opération
  const [newDate, setNewDate] = useState("");
  const [newTypeOp, setNewTypeOp] = useState("");
  const [newQuantite, setNewQuantite] = useState("");
  const [newPrix, setNewPrix] = useState("");
  const [newCreeLe, setNewCreeLe] = useState("");
  const [newInvestisseur, setNewInvestisseur] = useState("");
  const handleNewTypeOpChange = (e) => {
    setNewTypeOp(e);
  };

  const handleNewInvestisseurChange = (e) => {
    setNewInvestisseur(e);
  };

  const handleNewQuantiteChange = (e) => {
    setNewQuantite(e.target.value);
  };
  const handleNewDateChange = (e) => {
    setNewDate(e.target.value);
  };
  const handleNewPrixChange = (e) => {
    setNewPrix(e.target.value);
  };
  const handleNewCreeLeChange = (e) => {
    setNewCreeLe(e.target.value);
  };
  //// Edit opération
  const [editDate, setEditDate] = useState("");
  const [editTypeOp, setEditTypeOp] = useState("");
  const [editQuantite, setEditQuantite] = useState("");
  const [editPrix, setEditPrix] = useState("");
  const [editCreeLe, setEditCreeLe] = useState("");
  const [editInvestisseur, setEditInvestisseur] = useState("");
  const handleEditTypeOpChange = (e) => {
    setEditTypeOp(e);
  };

  const handleEditInvestisseurChange = (e) => {
    setEditInvestisseur(e);
  };

  const handleEditQuantiteChange = (e) => {
    setEditQuantite(e.target.value);
  };
  const handleEditDateChange = (e) => {
    setEditDate(e.target.value);
  };
  const handleEditPrixChange = (e) => {
    setEditPrix(e.target.value);
  };
  const handleEditCreeLeChange = (e) => {
    setNewCreeLe(e.target.value);
  };
  useEffect(() => {
    getTypeDoc();
    getCategorieDocument();
  }, [selectedCategories, newCategories]);
  useEffect(() => {
    getInvestisseur();
    getOperationType();
  }, []);
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/pmes/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const pmeData = await response.json();
        setPmeData(pmeData);
        {
          pmeData?.hm_accessibles?.map(async (key, index) =>
            key === "hm_souscriptions_en_cours"
              ? await getSouscriptionEnCours()
              : key === "hm_souscriptions_finalisees"
              ? await getSouscriptionFinaliseeHm()
              : key === "hm_investissements"
              ? await getInvestissements()
              : key === "hm_documents"
              ? await getDocumentHm()
              : key === "hm_documents_fusions"
              ? await getDocumentFusionHm()
              : key === "hm_operations"
              ? await getOperationHm()
              : null
          );
        }
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };
    const getInvestissements = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/pmes/${id}/hm_investissements`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setInvestissement(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getSouscriptionEnCours = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/pmes/${id}/hm_souscriptions_en_cours`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setSouscriptions_en_cours(data);
          });
      } catch (error) {
        console.log(error);
      }
    };

    const getOperationHm = async () => {
      try {
        await fetch(`https://www.fluxod.com/${api}/pmes/${id}/hm_operations`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            setOperationData(data);
            setWait(0);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getSouscriptionFinaliseeHm = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/pmes/${id}/hm_souscriptions_finalisees`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setSouscriptions_finalisees(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getDocumentHm = async () => {
      try {
        await fetch(`https://www.fluxod.com/${api}/pmes/${id}/hm_documents`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            setDocumentData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getDocumentFusionHm = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/pmes/${id}/hm_documents_fusion`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setDocumentFusionData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  const handleNewOperationSubmit = async () => {
    if (newTypeOp?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (newInvestisseur?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/operations/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              pme_id: id,
              operation_type_id: newTypeOp?.value,
              investisseur_id: newInvestisseur?.value,
              date: newDate,
              quantite: newQuantite,
              prix: newPrix,
            }),
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Opération Ajoutée");
          setModal_2(false);
          try {
            await fetch(
              `https://www.fluxod.com/${api}/pmes/${id}/hm_operations`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
              .then((response) => response.json())
              .then((data) => {
                setOperationData(data);
                setWait(0);
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (responseData && responseData.operation_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.operation_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleUpdateOperationSubmit = async () => {
    if (editTypeOp?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (editInvestisseur?.value == null || "") {
      toast.error("Investisseur ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/operations/${opId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              id: opId,
              pme_id: id,
              operation_type_id: editTypeOp?.value,
              investisseur_id: editInvestisseur?.value,
              date: editDate,
              quantite: editQuantite,
              prix: editPrix,
            }),
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Opération modifiée");
          setModal_3(false);
          try {
            await fetch(
              `https://www.fluxod.com/${api}/pmes/${id}/hm_operations`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
              .then((response) => response.json())
              .then((data) => {
                setOperationData(data);
                setWait(0);
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (responseData && responseData.operation_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.operation_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const [opId, setOpId] = useState("");
  const getOperationDetail = async (opId) => {
    try {
      await fetch(`https://www.fluxod.com/${api}/operations/${opId}/edit`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSelectedPme(data?.detail_operation["Identification"]["PME"]);
          setEditTypeOp(data?.detail_operation["Identification"]["Type"]);
          setEditInvestisseur(
            data?.detail_operation["Identification"]["Investisseur"]
          );
          setEditQuantite(data?.detail_operation["Identification"]["Quantité"]);
          setEditDate(data?.detail_operation["Identification"]["Date"]);
          setEditPrix(data?.detail_operation["Identification"].Prix);
          setModal_3(true);
        });
    } catch (error) {
      console.log(error);
    }
  };
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const handleGoBack = () => {
    window.history.back(); // Cela vous ramènera en arrière dans l'historique du navigateur
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  function extractSegment(url) {
    const baseUrl = `${backUrl}/`;
    const editSegment = "/edit";

    if (url.startsWith(baseUrl) && url.endsWith(editSegment)) {
      const start = baseUrl.length;
      const end = url.length - editSegment.length;
      return url.substring(start, end);
    }

    return null;
  }
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);

  const extractedText = extractSegment(previousPath);

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        {previousPath == `${backUrl}/${extractedText}/edit` ? (
          <LastModificationAlertShow path={extractedText} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={
                          type_compte == "client"
                            ? `${backUrl}/mes_participations`
                            : `${backUrl}/pmes/`
                        }
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        {type_compte == "client" ? "Mes participations" : "PME"}
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        pmeData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {pmeData.can_edit ? (
                        <Link
                          to={`${backUrl}/pmes/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {pmeData.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/pmes/${id}`}
                        />
                      ) : null}
                      {pmeData?.actions?.length > 0 ? (
                        <>
                          <>
                            &nbsp; &nbsp;
                            <Dropdown
                              isOpen={btnsecondary1}
                              toggle={() => setBtnsecondary1(!btnsecondary1)}
                            >
                              <DropdownToggle
                                tag="button"
                                className="btn btn-sm btn-secondary"
                              >
                                Actions <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu>
                                {pmeData?.actions.map((value, index) => (
                                  <>
                                    <DropdownItem
                                      onClick={() =>
                                        handleDropDownActionsClick(value.action)
                                      }
                                    >
                                      {value.label}
                                    </DropdownItem>
                                  </>
                                ))}
                                {downloadUrl && (
                                  <a
                                    href={downloadUrl}
                                    download={`${pmeData.sil.replace(
                                      / /g,
                                      "_"
                                    )}_Tableau_PME_${new Date()
                                      .toLocaleString("fr-FR", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })
                                      .replace(/[/: ]/g, "_")}.xlsx`}
                                    ref={downloadLinkRef}
                                    style={{ display: "none" }}
                                  >
                                    Télécharger le fichier excel
                                  </a>
                                )}
                                {downloadUrl1 && (
                                  <a
                                    href={downloadUrl1}
                                    download={`${pmeData.sil.replace(
                                      / /g,
                                      "_"
                                    )}_CERFA_2083_${new Date()
                                      .toLocaleString("fr-FR", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })
                                      .replace(/[/: ]/g, "_")}.xlsx`}
                                    ref={downloadLinkRef1}
                                    style={{ display: "none" }}
                                  >
                                    Télécharger le fichier excel
                                  </a>
                                )}
                              </DropdownMenu>
                            </Dropdown>
                          </>
                        </>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {pmeData?.detail_pme?.Identification ? (
                                <IdentificationCardPartenaire
                                  title="Identification"
                                  details={pmeData?.detail_pme?.Identification}
                                  ids={pmeData?.detail_pme?.ids}
                                />
                              ) : null}

                              {pmeData?.detail_pme?.["Comptabilité"] ? (
                                <IdentificationCard
                                  title="Comptabilité"
                                  details={
                                    pmeData?.detail_pme?.["Comptabilité"]
                                  }
                                />
                              ) : null}
                            </Col>
                            <Col sm="6">
                              {pmeData?.detail_pme?.[
                                "Renseignements juridiques"
                              ] ? (
                                <IdentificationCard
                                  title="Renseignements juridiques"
                                  details={
                                    pmeData?.detail_pme?.[
                                      "Renseignements juridiques"
                                    ]
                                  }
                                />
                              ) : null}

                              {pmeData?.detail_pme?.[
                                "Réduction d'impôt (DOM COM)"
                              ] ? (
                                <IdentificationCard
                                  title="Réduction d'impôt (DOM COM)"
                                  details={
                                    pmeData?.detail_pme?.[
                                      "Réduction d'impôt (DOM COM)"
                                    ]
                                  }
                                />
                              ) : null}
                            </Col>
                            <Row>
                              <Col sm="6">
                                <TableComponent
                                  title="Données comptables"
                                  header={
                                    pmeData?.detail_pme?.[
                                      "Données comptables"
                                    ]?.["Données comptables"]?.header
                                  }
                                  data={
                                    pmeData?.detail_pme?.[
                                      "Données comptables"
                                    ]?.["Données comptables"]?.data
                                  }
                                />
                              </Col>
                              <Col sm="6">
                                <TableComponent
                                  title={"Prestations"}
                                  header={
                                    pmeData?.detail_pme?.[
                                      "Prestations externalisées"
                                    ]?.["Prestations"]?.header
                                  }
                                  data={
                                    pmeData?.detail_pme?.[
                                      "Prestations externalisées"
                                    ]?.["Prestations"]?.data
                                  }
                                />
                              </Col>
                            </Row>

                            <>
                              {pmeData?.detail_pme?.documents?.map(
                                (section, index) => (
                                  <Col
                                    sm={Math.min(
                                      Math.floor(
                                        12 /
                                          pmeData?.detail_pme?.documents.length
                                      ),
                                      12
                                    )}
                                  >
                                    <Row>
                                      <Card key={`section_${index}`}>
                                        <CardBody>
                                          <CardTitle
                                            className="mb-3"
                                            style={{ whiteSpace: "pretty" }}
                                          >
                                            {section.section_name}
                                          </CardTitle>

                                          {section.data.map((file, i) => (
                                            <Row
                                              key={`_file_${i}`}
                                              style={{
                                                borderBottom: "1px solid #eee",
                                                padding: "10px 0",
                                              }}
                                            >
                                              <Col
                                                xs={2}
                                                style={{ display: "" }}
                                              >
                                                <div className="avatar-sm">
                                                  <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                                    <i className="bx bxs-file-doc" />
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={8}
                                                style={{
                                                  display: "inline-block",
                                                }}
                                              >
                                                <a
                                                  href={`https://www.fluxod.com/${api}/${
                                                    file?.link?.controller
                                                  }/${file?.link?.action}?${
                                                    Object.keys(
                                                      file.link.params
                                                    )[0]
                                                  }=${
                                                    file?.link?.params?.[
                                                      Object.keys(
                                                        file.link.params
                                                      )[0]
                                                    ]
                                                  }&jti=${token}`}
                                                  className="text-dark"
                                                  style={{
                                                    textDecoration: "none",
                                                    display: "block",
                                                  }}
                                                >
                                                  <h5
                                                    className="font-size-14 mb-1"
                                                    style={{ paddingLeft: 10 }}
                                                  >
                                                    {file.nom}
                                                  </h5>
                                                  <small
                                                    style={{ paddingLeft: 10 }}
                                                  >
                                                    {file.type}
                                                  </small>
                                                </a>
                                              </Col>
                                              <Col xs={2}>
                                                <div
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  {file.link && (
                                                    <a
                                                      href={`https://www.fluxod.com/${api}/${
                                                        file?.link?.controller
                                                      }/${file?.link?.action}?${
                                                        Object.keys(
                                                          file.link.params
                                                        )[0]
                                                      }=${
                                                        file?.link?.params?.[
                                                          Object.keys(
                                                            file.link.params
                                                          )[0]
                                                        ]
                                                      }&jti=${token}`}
                                                      className="text-dark"
                                                    >
                                                      <i className="bx bx-download h3 m-0" />
                                                    </a>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </Row>
                                  </Col>
                                )
                              )}
                            </>

                            {pmeData?.detail_pme?.["Augmentations de capital"]
                              ?.Tranches.header ? (
                              <Row>
                                <Col sm="12">
                                  <TableComponent
                                    title="Augmentations de capital"
                                    header={
                                      pmeData?.detail_pme?.[
                                        "Augmentations de capital"
                                      ]?.Tranches.header
                                    }
                                    data={
                                      pmeData?.detail_pme?.[
                                        "Augmentations de capital"
                                      ]?.Tranches.data
                                    }
                                  />
                                </Col>
                              </Row>
                            ) : null}
                            <Row>
                              <Col sm="12">
                                {" "}
                                {pmeData?.detail_pme?.Audit ? (
                                  <AuditCard
                                    title="Audit"
                                    auditData={pmeData?.detail_pme?.Audit}
                                  />
                                ) : null}
                              </Col>
                            </Row>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "operation" && (
                    <div>
                      {!loading ? (
                        <>
                          {operationData?.can_add ? (
                            <div style={{ textAlign: "left" }}>
                              <Link
                                id={`edittooltip-}`}
                                className="btn btn-sm btn-primary"
                                onClick={() => setModal_2(true)}
                              >
                                <i className="bx bx-plus"></i>Ajouter
                              </Link>
                            </div>
                          ) : null}
                          <OperationList
                            title={operationData}
                            data={operationData?.data}
                            header={operationData?.header}
                            itemsPerPage={10}
                            onClick={(documentId) => {
                              getOperationDetail(documentId);
                              setOpId(documentId);
                            }}
                          />
                          <Modal
                            isOpen={modal_2}
                            toggle={() => setModal_2(!modal_2)}
                          >
                            <ModalHeader
                              toggle={() => setModal_2(!modal_2)}
                              tag="h4"
                            >
                              Nouvelle opération
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleNewOperationSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">PME</Label>
                                      <Input
                                        name="pme"
                                        type="text"
                                        placeholder="PME"
                                        value={pmeData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={newType}
                                        onChange={handleNewTypeOpChange}
                                        options={renderOperationTypeOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investisseur
                                      </Label>
                                      <Select
                                        defaultValue={newInvestisseur}
                                        onChange={handleNewInvestisseurChange}
                                        options={renderInvestisseurOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Date</Label>
                                      <ReactInputMask
                                        mask="99/99/9999"
                                        value={newDate}
                                        className="form-control input-color"
                                        onChange={(dateString) => {
                                          setNewDate(dateString.target.value);
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Prix</Label>
                                      <Input
                                        name="prix"
                                        type="number"
                                        placeholder="Prix"
                                        value={newPrix}
                                        onChange={(e) =>
                                          setNewPrix(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Quantité
                                      </Label>
                                      <Input
                                        name="quantite"
                                        type="number"
                                        placeholder="Quantité"
                                        value={newQuantite}
                                        onChange={(e) =>
                                          setNewQuantite(e.target.value)
                                        }
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Créer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={modal_3}
                            toggle={() => setModal_3(!modal_3)}
                          >
                            <ModalHeader
                              toggle={() => setModal_3(!modal_3)}
                              tag="h4"
                            >
                              Modification de l'opération
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleUpdateOperationSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">PME</Label>
                                      <Input
                                        name="pme"
                                        type="text"
                                        placeholder="PME"
                                        value={pmeData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={editTypeOp}
                                        onChange={handleEditTypeOpChange}
                                        options={renderOperationTypeOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investisseur
                                      </Label>
                                      <Select
                                        defaultValue={editInvestisseur}
                                        onChange={handleEditInvestisseurChange}
                                        options={renderInvestisseurOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Date</Label>
                                      <ReactInputMask
                                        mask="99/99/9999"
                                        value={editDate}
                                        className="form-control input-color"
                                        onChange={(dateString) => {
                                          setEditDate(dateString.target.value);
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Prix</Label>
                                      <Input
                                        name="prix"
                                        type="number"
                                        placeholder="Prix"
                                        value={editPrix}
                                        onChange={(e) =>
                                          setEditPrix(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Quantité
                                      </Label>
                                      <Input
                                        name="quantite"
                                        type="number"
                                        placeholder="Quantité"
                                        value={editQuantite}
                                        onChange={(e) =>
                                          setEditQuantite(e.target.value)
                                        }
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Modifier
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          {documentData?.can_add ? (
                            <div style={{ textAlign: "left" }}>
                              <Link
                                id={`edittooltip-}`}
                                className="btn btn-sm btn-primary"
                                onClick={() => setModal_1(true)}
                              >
                                <i className="bx bx-plus"></i>Ajouter
                              </Link>
                            </div>
                          ) : null}

                          <DocumentHm
                            title={documentData}
                            data={documentData?.data}
                            header={documentData?.header}
                            itemsPerPage={10}
                            onClick={(documentId) => {
                              getDocumentDetail(documentId);
                              getTypeDoc(documentId);
                              setDocId(documentId);
                            }}
                            controller="pme_documents"
                          />
                          <Modal isOpen={modal} toggle={() => setModal(!modal)}>
                            <ModalHeader
                              toggle={() => setModal(!modal)}
                              tag="h4"
                            >
                              Détails du document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  setModal(false);
                                  handleUpdateSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">PME</Label>
                                      <Input
                                        name="pme"
                                        type="text"
                                        placeholder="PME"
                                        value={selectedPme}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={selectedCategories}
                                        onChange={handleCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={selectedType}
                                        onChange={handleTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={selectedNom}
                                        onChange={(e) =>
                                          setSelectedNom(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={selectedComment}
                                        onChange={(e) =>
                                          setSelectedComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier :
                                      </Label>
                                      <FilePreview
                                        fileUrl={
                                          docData?.detail_pme_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                      />
                                      <a
                                        href={
                                          docData?.detail_pme_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Télécharger le fichier
                                      </a>
                                      <input
                                        type="file"
                                        onChange={handleFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        className="btn btn-success save-user"
                                      >
                                        Enregistrer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={modal_1}
                            toggle={() => setModal_1(!modal_1)}
                          >
                            <ModalHeader
                              toggle={() => setModal_1(!modal_1)}
                              tag="h4"
                            >
                              Nouveau document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleNewSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">PME</Label>
                                      <Input
                                        name="pme"
                                        type="text"
                                        placeholder="PME"
                                        value={pmeData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={newCategories}
                                        onChange={handleNewCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={newType}
                                        onChange={handleNewTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={newNom}
                                        onChange={handleNomChange}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={newComment}
                                        onChange={(e) =>
                                          setNewComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier
                                      </Label>

                                      <input
                                        type="file"
                                        onChange={handleNewFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Créer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents_fusions" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <DocumentFusionHm
                            title={documentFusionData}
                            data={documentFusionData?.data}
                            header={documentFusionData?.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "souscriptions_finalisees" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <SouscriptionFinaliseesListHm
                            title={souscriptions_finalisees}
                            data={souscriptions_finalisees?.data}
                            header={souscriptions_finalisees?.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "souscriptions_en_cours" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <SouscriptionFinaliseesListHm
                            title={souscriptions_en_cours}
                            data={souscriptions_en_cours?.data}
                            header={souscriptions_en_cours?.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "investissements" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <InvestissementListHm
                            title={investissements}
                            data={investissements?.data}
                            header={investissements?.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default PmeDetail;
